// @flow
import { fromNullable, type Option } from 'fp-ts/lib/Option';

export const concat = (str: string) => (str2: string) => `${str}${str2}`;

export const classNames = (...strs: Array<string>) => strs.filter(str => typeof str === 'string' && str.length > 0).join(' ');

export const trimLeadingSlash = (str: string) => str.replace(/^\/+/g, '');

// eslint-disable-next-line
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const isEmail = (email: string) => !emailRegex.test(email);

// Curried, data-last wrapper for String#split
export const split = (splitOn: string) => (str: string) => str.split(splitOn);

export const wrapInputId = (id: string) => `input-${id}`;
export const wrapOptionId = (id: string) => `option-${id}`;

export const deSnake = (str: string) => str.replace(/_/g, ' ');
export const doSnake = (str: string) => str.replace(/\s+/g, '_').toLowerCase();
export const swatchAsset = (str: string) =>
  fromNullable(str)
    .map(x => x.split('/'))
    .map(x => x[x.length - 1])
    .map(_str => `/${_str.charAt(0)}/${_str.charAt(1)}/${_str.slice(0, -4)}_2x${_str.slice(-4)}`)
    .getOrElseValue('');

export const findNumberInString = (str: string): Option<number | string> =>
  fromNullable(str.match(/[0-9]+([.|,][0-9]+)?/))
    .map(x => x[0])
    .map(x => parseFloat(x).toFixed(2));

export const filterNotEmpty = (value: string) => value !== '';

// Converts an any to snake_case.
export const snakecase = (str: any): string =>
  str
    .toString()
    .replace(/ /g, '_')
    .toLowerCase();



// WEBPACK FOOTER //
// ./src/helpers/strings.js